import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { Input } from 'modules/common/components/Input/Input';
import QRCode from 'qrcode.react';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

type QRCodeGeneratorProps = {
  onChange: (url: string) => void;
};

const INPUT_ID = 'qr-code-url-input';

export const QRCodeGenerator = ({ onChange }: QRCodeGeneratorProps) => {
  const [url, setUrl] = useState<string>('');
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false });

  const onSetUrl = (e: ChangeEvent<HTMLInputElement>) => setUrl(e.target.value);
  const onClickGenerate = () => onChange(url);

  const hasUrl = url.length > 0;

  return (
    <>
      <Text pb={1} fontWeight='bold' as='label' htmlFor={INPUT_ID} fontSize='sm'>
        {t('sideMenu.qrCodeMenu.inputLabel')}
      </Text>
      <Input
        id={INPUT_ID}
        size='sm'
        maxLength='1000'
        placeholder='https://example.com'
        value={url}
        onChange={onSetUrl}
        p={2}
        borderRadius={'base'}
        borderColor={'gray.500'}
        _placeholder={{ color: 'font.300' }}
      />
      <Box py={4}>
        <Text fontWeight='bold' pb={1} fontSize='sm'>
          {t('sideMenu.qrCodeMenu.previewLabel')}
        </Text>
        <Flex justify='center' opacity={hasUrl ? 1 : 0.5}>
          <QRCode value={url} renderAs='svg' />
        </Flex>
      </Box>
      <Button isDisabled={!hasUrl} onClick={onClickGenerate} mt={4} w='full' variant='action' size='sm'>
        {t('sideMenu.qrCodeMenu.generateButton')}
      </Button>
    </>
  );
};
